import { render, staticRenderFns } from "./TransactionOverview.vue?vue&type=template&id=05ffad97&"
import script from "./TransactionOverview.vue?vue&type=script&lang=js&"
export * from "./TransactionOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports